import {
  PrivateProsecution,
  PrivateProsecutionFeedback,
  PrivateProsecutionReport,
} from "types";
import apiClient from "../lib/apiClients";

// PrivateProsecution
export const fetchPrivateProsecution = async (data: PrivateProsecution[]) => {
  const response = await apiClient.get(
    "/prosecutor-police/private-prosecutions/",
  );
  return response.data;
};
export const fetchPrivateProsecutionById = async (id: string | number) => {
  const response = await apiClient.get(
    `/prosecutor-police/private-prosecutions/${id}/`,
  );
  return response.data;
};
export const addPrivateProsecution = async (data: any) => {
  const response = await apiClient.post(
    "/prosecutor-police/private-prosecutions/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editPrivateProsecution = async (data: any) => {
  const response = await apiClient.patch(
    "/prosecutor-police/private-prosecutions/" + data?.id + "/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const deletePrivateProsecution = async (
  reporter: PrivateProsecution,
) => {
  const response = await apiClient.delete(
    "/prosecutor-police/private-prosecutions/" + reporter?.id + "/",
  );
  return response.data;
};

// PrivateProsecutionReport
export const fetchPrivateProsecutionReports = async (
  data: PrivateProsecutionReport[],
) => {
  const response = await apiClient.get(
    "/prosecutor-police/private-prosecution-reports/",
  );
  return response.data;
};
export const addPrivateProsecutionReport = async (
  data: PrivateProsecutionReport,
) => {
  const response = await apiClient.post(
    "/prosecutor-police/private-prosecution-reports/",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};
export const editPrivateProsecutionReport = async (data: any) => {
  const response = await apiClient.patch(
    "/prosecutor-police/private-prosecution-reports/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deletePrivateProsecutionReport = async (
  reporter: PrivateProsecutionReport,
) => {
  const response = await apiClient.delete(
    "/prosecutor-police/private-prosecution-reports/" + reporter?.id + "/",
  );
  return response.data;
};

// PrivateProsecutionFeedback
export const fetchPrivateProsecutionFeedbacks = async (
  data: PrivateProsecutionFeedback[],
) => {
  const response = await apiClient.get(
    "/prosecutor-police/private-prosecution-feedbacks/",
  );
  return response.data;
};
export const addPrivateProsecutionFeedback = async (
  data: PrivateProsecutionFeedback,
) => {
  const response = await apiClient.post(
    "/prosecutor-police/private-prosecution-feedbacks/",
    data,
  );
  return response.data;
};
export const editPrivateProsecutionFeedback = async (data: any) => {
  const response = await apiClient.patch(
    "/prosecutor-police/private-prosecution-feedbacks/" + data?.id + "/",
    data,
  );
  return response.data;
};
export const deletePrivateProsecutionFeedback = async (
  feedback: PrivateProsecutionFeedback,
) => {
  const response = await apiClient.delete(
    "/prosecutor-police/private-prosecution-feedbacks/" + feedback?.id + "/",
  );
  return response.data;
};
